import { demoFile, component, componentWithVariants, variant, story, CLICK, POPUP } from 'system/demo';
import { ModDashboardQueue, ModDashboardQueueGeneral } from 'open-modules/zdf/component/moddashboard/moddashboardqueue';
import { ModerationFilters } from 'open-modules/zdf/component/moddashboard/moddashboardFilters';
import { getQueueSubsetCounts, useFilteredQueuesOfUser } from 'open-modules/zdf/component/moddashboard/moddashboardqueuehooks';

const modDashboardDemoData = {
  modulePublicQuestion: {
    thread1: { key: 't1', from: 'a', question: 'Q1', time: Date.now() },
    thread2: { key: 't2', from: 'b', question: 'Q2', time: Date.now() - 1000 },
  },
  modTaskQueues: {
    thread1: {
      c_t1_awaiting_ai: { key: 'task_ai', from: 'u1', time: Date.now() },
      c_t1_awaiting_report: { key: 'task_rep', from: 'u2', time: Date.now() },
    },
    thread2: {},
  },
  modTaskSubQueues: {
    thread1: { awaiting_decision: {}, human_approved: {}, auto_approved: {}, rejected: {} },
    thread2: { awaiting_decision: {}, human_approved: {}, auto_approved: {}, rejected: {} },
  },
  globalQueueCounts: {},
  demoAuthors: {},
  moduleUserBookmarks: {},
  moduleUserBookmarksCount: {},
  serverCalls: {},
  instanceData: { thread1: { collections: {}, globals: {} } },
};

demoFile('open-modules/zdf/component/moddashboard/moddashboardqueue');

const baseState = {
  collections: modDashboardDemoData.instanceData.thread1.collections,
  globals: modDashboardDemoData.instanceData.thread1.globals,
  modulePublic: {
    question: modDashboardDemoData.modulePublicQuestion,
    moderation: {
      queue: {
        ...modDashboardDemoData.modTaskQueues.thread1,
        ...modDashboardDemoData.modTaskQueues.thread2,
      },
      queue_filtered: {
        awaiting_decision: {
          ...modDashboardDemoData.modTaskSubQueues.thread1.awaiting_decision,
          ...modDashboardDemoData.modTaskSubQueues.thread2.awaiting_decision,
        },
        human_approved: {
          ...modDashboardDemoData.modTaskSubQueues.thread1.human_approved,
          ...modDashboardDemoData.modTaskSubQueues.thread2.human_approved,
        },
        auto_approved: {
          ...modDashboardDemoData.modTaskSubQueues.thread1.auto_approved,
          ...modDashboardDemoData.modTaskSubQueues.thread2.auto_approved,
        },
        rejected: {
          ...modDashboardDemoData.modTaskSubQueues.thread1.rejected,
          ...modDashboardDemoData.modTaskSubQueues.thread2.rejected,
        },
      },
      count_queue_filtered: {
        ...modDashboardDemoData.globalQueueCounts,
      },
      moderator: modDashboardDemoData.demoAuthors,
    },
  },
  moduleUserGlobal: {
    bookmarks: { ...modDashboardDemoData.moduleUserBookmarks },
    bookmarks_count: { ...modDashboardDemoData.moduleUserBookmarksCount },
  },
  serverCall: modDashboardDemoData.serverCalls,
  roles: ['Moderator'],
  sessionData: { 'moderation/sessionId': 'mySessionID' },
  embeddedInstanceData: {
    question: {
      [modDashboardDemoData.modulePublicQuestion.thread1.key]: modDashboardDemoData.instanceData.thread1,
    },
  },
};

const queueStories: any[] = [];

component('ModDashboardQueueGeneral', ModDashboardQueueGeneral, {
  state: baseState,
}, queueStories);

component('ModDashboardQueue', ModDashboardQueue, {
  state: baseState,
});
